var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';
import { FormActions, FormStates, FormReducer } from './RXFormEvents';
// import Select from 'react-select';
import RXSelect from './RXSelect';
import RXTags from './RXTags';
import RXColor from './RXColor';
import RXMap from './RXMap';
import RXTree from './RXTree';
import RXPlainText from './RXPlainText';
import RXRichText from './RXRichText';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
var _ = require('lodash');

var logdown = require('logdown');
var console = logdown('rx-forms-rx-input', { prefixColor: '#d50000' });

var isPromise = function isPromise(value) {

    return value && Object.prototype.toString.call(value) === "[object Promise]";
};

var RXInput = function (_Component) {
    _inherits(RXInput, _Component);

    function RXInput(props) {
        _classCallCheck(this, RXInput);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidMount = function () {

            _this.unSubscribeFormStore = _this.props.formstore.subscribe(function () {
                var state = _this.formstore.getState();

                console.log('receive form event: ' + state.state + ' for input ' + _this.props.id);
                switch (state.state) {
                    case FormStates.WILL_VALIDATE:

                        var event = { target: { id: _this.props.id, value: _this.props.value } };
                        console.log('event: ' + JSON.stringify(event));
                        _this.onBlur(event);
                        // this.formstore.dispatch({
                        //     type: FormActions.DID_VALIDATE,
                        //     valid: this.state.valid,
                        //     feedbackMessage: this.state.feedbackMessage
                        // });
                        break;
                    default:
                        break;
                }
            });
        };

        _this.onBlur = function (event) {

            console.log('in onBlur for ' + event.target.id + ' with validators: ' + JSON.stringify(_this.props.validators));

            // this.props.validators.map((validator, index) => {
            var valid = false;
            var message = "";

            for (var i = 0; i < _this.props.validators.length; i += 1) {

                var validator = _this.props.validators[i];

                var formvalidator = _this.props.formvalidators[validator];
                console.log('found formvalidator ' + formvalidator);

                if (formvalidator === undefined) {
                    //UNDEFINED VALIDATOR
                    console.warn('undefined validator ' + validator);
                } else {
                    console.log('start with *errors:*', _this.props.errors);

                    var result = formvalidator(event.target);

                    if (isPromise(result)) {

                        _this.setState({ visibleSpinner: true, disabled: true, valid: false, invalid: false });

                        result.then(function (data) {
                            _this.setState({ visibleSpinner: false, disabled: false, invalid: false, valid: true, feedbackMessage: data.message });
                        }).catch(function (error) {
                            _this.setState({ visibleSpinner: false, disabled: false, invalid: true, valid: false, feedbackMessage: error.message });
                        });
                        break;
                    } else {
                        console.log('done valid with: ' + result.success);
                        if (result.success) {
                            _this.setState({ invalid: false, valid: true, feedbackMessage: result.message });
                            valid = true;
                            //Remove error from submit
                            // delete (this.props.errors[`${event.target.id}`])
                            _.omit(_this.props.errors, [event.target.id]);
                            console.log('done deleted error');
                        } else {
                            //REVIEW: 
                            console.log('in target: ' + event.target.id);
                            _this.props.errors['' + event.target.id] = { message: result.message };
                            console.log('after set error: ' + JSON.stringify(_this.props.errors));
                            console.log('after set error: ' + JSON.stringify(_this.props.errors['' + event.target.id]));
                            _this.setState({ invalid: true, valid: false, feedbackMessage: result.message });
                            valid = false;
                            message = result.message;
                            break;
                        }
                    }
                }
            }

            // if(!valid){
            //     this.props.errors[`${event.target.id}`] = {message: message}
            // }else{
            //     delete this.props.errors[`${event.target.id}`]
            // }
        };

        console.log('constructor log rxinput proprs: ' + JSON.stringify(_this.props));
        _this.state = {
            invalid: false,
            valid: false,
            feedbackMessage: "",
            visibleSpinner: false,
            disabled: false,
            value: _this.props.value
        };
        _this.formstore = _this.props.formstore;
        return _this;
    }

    RXInput.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {

        // console.log(`12000: in componentDidUpdate with `, this.props.value);
        if (this.props.value != prevProps.value) {
            console.log('12000: in componentDidUpdate with ', this.props.value);
            this.setState({ value: this.props.value });
        }
    };

    RXInput.prototype.render = function render() {
        var _this2 = this;

        if (this.props.type === "checkbox") {
            //REVIEW: make strong
            var checked = this.state.value;
            return React.createElement(CustomInput, _extends({ checked: checked }, this.props, { onBlur: this.onBlur, inline: true }));
        } else if (this.props.type === "file") {
            //REVIEW: make strong
            var checked = this.state.value;
            return React.createElement(CustomInput, _extends({}, this.props, { onBlur: this.onBlur, onChange: function onChange(e) {
                    return _this2.props.onFileAdded(e);
                } }));
        } else if (this.props.type === "switch") {
            //REVIEW: make strong
            console.log('received checked: ', this.state.value);
            var checked = this.state.value && this.state.value != "" ? this.state.value : false;
            return React.createElement(CustomInput, _extends({ type: 'switch', checked: checked }, this.props, { onBlur: this.onBlur }));
        } else if (this.props.type === "tag") {
            //REVIEW: make strong
            var checked = this.state.value;

            return React.createElement(RXTags, this.props);
        } else if (this.props.type === "color") {
            //REVIEW: make strong
            var checked = this.state.value;

            return React.createElement(RXColor, this.props);
        } else if (this.props.type === "tree") {

            return React.createElement(RXTree, this.props);
        } else if (this.props.type === "plaintext") {

            return React.createElement(RXPlainText, this.props);
        } else if (this.props.type === "richtext") {

            return React.createElement(RXRichText, this.props);
        } else if (this.props.type === "map") {

            return React.createElement(RXMap, this.props);
        } else if (this.props.type === "select") {
            return React.createElement(
                React.Fragment,
                null,
                React.createElement(RXSelect, _extends({}, this.props, { invalid: this.state.invalid, onBlur: this.onBlur, feedbackMessage: this.state.feedbackMessage }))
            );
        } else if (this.props.type === "number") {

            console.log('in number props: ', this.props);
            // var { onChange, value, props } = this.props;

            var _props = this.props,
                onChange = _props.onChange,
                value = _props.value,
                props = _objectWithoutProperties(_props, ['onChange', 'value']);
            //FIX value for 0


            value = value === "" || value === undefined ? Number(0) : Number(value);
            console.log('props,value on render number: ', props, value);

            var localOnChange = function localOnChange(e) {
                console.log('in number localOnChange: ', e);
                // e.target.type = "number";
                var ev = {
                    target: {
                        value: e.target.value,
                        id: e.target.id,
                        type: 'number'
                    }
                };
                _this2.props.onChange(ev);
            };

            var localOnBlur = function localOnBlur(e) {
                console.log('in localOnBlur: ', e);
                e.target.value = e.target.value === "" || e.target.value === undefined ? Number(0) : Number(e.target.value);
                console.log('after reTarget: ', e);
                _this2.onBlur(e);
            };

            return React.createElement(Input, _extends({ invalid: this.state.invalid, valid: this.state.valid, onBlur: localOnBlur, disabled: this.state.disabled, value: Number(value), onChange: localOnChange }, props));
        } else {

            // const {value, onChange, props} = {...this.props}
            var _props2 = _.omit(this.props, 'onFileAdded'); //Fix for invalid props
            return React.createElement(
                React.Fragment,
                null,
                this.props.plaintext ? React.createElement(Input, _extends({ plaintext: true, style: { border: "1px solid #ced4da", backgroundColor: "#e1f5fe" }, invalid: this.state.invalid, valid: this.state.valid, onBlur: this.onBlur, disabled: this.state.disabled, className: 'form-control' }, _props2, { onChange: function onChange() {} })) : React.createElement(Input, _extends({ invalid: this.state.invalid, valid: this.state.valid, onBlur: this.onBlur, disabled: this.state.disabled }, _props2)),
                this.state.visibleSpinner && React.createElement('span', { style: { position: "absolute", zIndex: 100, top: 5, left: 0, right: 0, marginLeft: "auto", marginRight: "auto", width: 28, height: 28, fontSize: 28, color: "gray" }, className: 'fa fa-spinner fa-spin' }),
                React.createElement(
                    FormFeedback,
                    { valid: this.state.valid },
                    this.state.feedbackMessage
                )
            );
        }
    };

    return RXInput;
}(Component);

RXInput.defaultProps = {
    ininputgroup: 0
};

export default RXInput;